import Vue from 'vue'
import {
  Carousel,
  CarouselItem,
} from 'element-ui'

Vue.use(Carousel);
Vue.use(CarouselItem);
